import { tenantPath } from "helpers/tenant_path";
import { BOOKING_PATH, INTERVIEWS_PATH } from "packs/client_app/config";
import { getHeaders } from "packs/client_app/config/request_headers";

export const getInterview = (id: string) => {
  const path = `${tenantPath(INTERVIEWS_PATH(id))}`;

  return fetch(path, {
    method: "GET",
    headers: getHeaders(),
  });
};

export const getInterviewAvailable = (id: string) => {
  const path = `${tenantPath(BOOKING_PATH(id))}`;

  return fetch(path, {
    method: "GET",
    headers: getHeaders(),
  });
};

export const createInterviewAvailable = (
  id: string,
  event_id: string | null,
  start_time: string,
  end_time: string
) => {
  const path = `${tenantPath(INTERVIEWS_PATH(id))}`;
  return fetch(path, {
    method: "PUT",
    headers: getHeaders(),
    body: JSON.stringify({
      event_id,
      start_time,
      end_time,
    }),
  });
};

export const createBooking = (
  id: string,
  event_id: string | null,
  start_time: string,
  end_time: string,
  is_admin: boolean,
  status?: string
) => {
  const path = `${tenantPath(BOOKING_PATH(id))}`;
  return fetch(path, {
    method: "PUT",
    headers: getHeaders(),
    body: JSON.stringify({
      event_id,
      start_time,
      end_time,
      status,
      is_admin,
    }),
  });
};

export const cancelBooking = (id: string) => {
  const path = `${tenantPath(BOOKING_PATH(id))}`;
  return fetch(path, {
    method: "DELETE",
    headers: getHeaders(),
  });
};

export const deleteInterviewAvailable = (id: string, event_id: string) => {
  const path = `${tenantPath(INTERVIEWS_PATH(id))}`;
  return fetch(path, {
    method: "DELETE",
    headers: getHeaders(),
    body: JSON.stringify({
      event_id,
    }),
  });
};
